(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	ファーストビューのアニメーション
	======================================*/
		const fvMq = window.matchMedia("(max-width: 768px)");
		const fvSelector = ".topFv .topFv__container";
		let fvCurrentMode = "";
		let fvStarted = false;
		let fvRafId = 0;

		const getFvMode = () => {
			return fvMq.matches ? "sp" : "pc";
		};

		const getActiveFvContainer = () => {
			const selector = fvMq.matches
				? `${fvSelector}.is-spVideo`
				: `${fvSelector}.is-pcVideo`;

			return document.querySelector(selector);
		};

		const getFvPaths = (container) => {
			return Array.from(
				container.querySelectorAll(
					"svg path, svg line, svg polyline, svg polygon, svg circle, svg rect",
				),
			);
		};

		const resetFvContainer = (container) => {
			container.classList.remove("is-fv-ready");

			getFvPaths(container).forEach((path) => {
				path.classList.remove("is-animation");
				path.style.removeProperty("stroke-dasharray");
				path.style.removeProperty("stroke-dashoffset");
				path.style.removeProperty("stroke-linecap");
				path.style.removeProperty("stroke-linejoin");
			});
		};

		const prepareFvContainer = (container) => {
			getFvPaths(container).forEach((path) => {
				const length = Math.max(path.getTotalLength(), 1) + 1;

				path.style.strokeDasharray = `${length}`;
				path.style.strokeDashoffset = `${length}`;
				path.style.strokeLinecap = "round";
				path.style.strokeLinejoin = "round";
			});
		};

		const startFvAnimation = (force = false) => {
			const mode = getFvMode();

			if (!force && fvStarted && fvCurrentMode === mode) {
				return;
			}

			const containers = Array.from(
				document.querySelectorAll(fvSelector),
			);
			if (containers.length === 0) return;

			containers.forEach((container) => {
				resetFvContainer(container);
			});

			const activeContainer = getActiveFvContainer();
			if (!activeContainer) return;

			prepareFvContainer(activeContainer);

			if (fvRafId) {
				window.cancelAnimationFrame(fvRafId);
			}

			fvRafId = window.requestAnimationFrame(() => {
				fvRafId = window.requestAnimationFrame(() => {
					activeContainer.classList.add("is-fv-ready");

					getFvPaths(activeContainer).forEach((path) => {
						path.classList.add("is-animation");
					});

					fvStarted = true;
					fvCurrentMode = mode;
				});
			});
		};

		startFvAnimation(true);

		fvMq.addEventListener("change", () => {
			startFvAnimation(true);
		});

		const fvVideo = document.querySelector(".js-fvVideo");
		const fvVideoMq = window.matchMedia("(max-width: 768px)");
		let fvVideoMode = "";

		const getFvVideoMode = () => {
			return fvVideoMq.matches ? "sp" : "pc";
		};

		const getFvVideoSrc = (video) => {
			const isSp = fvVideoMq.matches;

			const webmSrc = isSp
				? video.dataset.srcSpWebm
				: video.dataset.srcPcWebm;

			const mp4Src = isSp
				? video.dataset.srcSpMp4
				: video.dataset.srcPcMp4;

			const canPlayWebm = video.canPlayType("video/webm") !== "";

			return canPlayWebm && webmSrc ? webmSrc : mp4Src;
		};

		const setFvVideoSource = async (video, force = false) => {
			const nextMode = getFvVideoMode();
			const nextSrc = getFvVideoSrc(video);

			if (!nextSrc) return;

			if (
				!force &&
				fvVideoMode === nextMode &&
				video.currentSrc === nextSrc
			) {
				return;
			}

			const shouldResume = !video.paused;
			const currentTime = video.currentTime || 0;

			video.pause();
			video.src = nextSrc;
			video.load();

			video.addEventListener(
				"loadedmetadata",
				() => {
					if (currentTime > 0) {
						try {
							video.currentTime = currentTime;
						} catch (error) {}
					}
				},
				{ once: true },
			);

			fvVideoMode = nextMode;

			if (shouldResume) {
				try {
					await video.play();
				} catch (error) {}
			}
		};

		if (fvVideo) {
			setFvVideoSource(fvVideo, true);

			window.setTimeout(() => {
				fvVideo.play().catch(() => {});
			}, 8000);

			fvVideoMq.addEventListener("change", async () => {
				await setFvVideoSource(fvVideo, true);

				if (!fvVideo.paused) {
					fvVideo.play().catch(() => {});
				}
			});
		}

		/*======================================
	コンセプトの時計のアニメーション
	======================================*/
		const conceptClockContainer = document.querySelector(
			".secConcept__clockContainer",
		);

		if (conceptClockContainer) {
			const conceptClockPaths = conceptClockContainer.querySelectorAll(
				"svg path, svg line, svg polyline, svg polygon, svg circle, svg rect",
			);

			conceptClockPaths.forEach((path) => {
				const length = path.getTotalLength();

				path.style.strokeDasharray = `${length}`;
				path.style.strokeDashoffset = `${length}`;
				path.style.strokeLinecap = "round";
				path.style.strokeLinejoin = "round";
				path.classList.add("is-clockAnimation");
			});
		}

		/*======================================
	ベット画像のアニメーション
	======================================*/
		const target = document.querySelector(".js-roomAnimation");

		if (!target) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio >= 0.5) {
						target.classList.add("is-active");
					} else {
						target.classList.remove("is-active");
					}
				});
			},
			{
				threshold: [0, 0.5, 1],
			},
		);
		observer.observe(target);

		/*======================================
	Inside the Villaのアニメーション
	======================================*/
		const insideAnime = document.querySelector(".secInsideCardAnime");
		const insideContainer = insideAnime?.querySelector(
			".secInsideCardAnime__container",
		);

		if (insideAnime && insideContainer) {
			const insidePaths = insideContainer.querySelectorAll(
				"svg path, svg line, svg polyline, svg polygon, svg circle, svg rect",
			);

			insidePaths.forEach((path) => {
				const length = path.getTotalLength();

				path.style.strokeDasharray = `${length}`;
				path.style.strokeDashoffset = `${length}`;
				path.style.strokeLinecap = "round";
				path.style.strokeLinejoin = "round";
			});

			let hasStartedInsideAnimation = false;
			let tickingInsideAnimation = false;
			const EPS = 1;

			const isFullyVisibleInViewport = (el) => {
				const rect = el.getBoundingClientRect();

				return (
					rect.top >= -EPS && rect.bottom <= window.innerHeight + EPS
				);
			};

			const startInsideAnimation = () => {
				if (hasStartedInsideAnimation) return;
				if (!isFullyVisibleInViewport(insideAnime)) return;

				hasStartedInsideAnimation = true;
				insideAnime.classList.add("is-started");

				insidePaths.forEach((path) => {
					path.classList.add("is-insideAnimation");
				});

				window.removeEventListener("scroll", checkInsideAnimation);
				window.removeEventListener("resize", checkInsideAnimation);
				window.removeEventListener("load", startInsideAnimation);
			};

			const checkInsideAnimation = () => {
				if (tickingInsideAnimation) return;

				tickingInsideAnimation = true;

				window.requestAnimationFrame(() => {
					startInsideAnimation();
					tickingInsideAnimation = false;
				});
			};

			window.addEventListener("load", startInsideAnimation);
			window.addEventListener("scroll", checkInsideAnimation, {
				passive: true,
			});
			window.addEventListener("resize", checkInsideAnimation);

			checkInsideAnimation();
		}

		/*======================================
	Space & Artworksの見出し画像のアニメーション
	======================================*/
		const artworksTitle = document.querySelector(
			".secSpace__right .top-ttl",
		);
		const artworksGroups =
			artworksTitle?.querySelectorAll(".top-ttl__img g");

		if (artworksTitle && artworksGroups?.length) {
			const animationDuration = 3;
			const startDelay = 0.6;

			artworksGroups.forEach((g, index) => {
				const paths = g.querySelectorAll(
					"path, line, polyline, polygon, circle, rect",
				);

				const delay = startDelay + index * animationDuration * 0.03;

				paths.forEach((path) => {
					const length = path.getTotalLength();

					path.style.setProperty("--length", `${length}`);
					path.style.setProperty("--space-delay", `${delay}s`);
					path.style.strokeDasharray = `${length}`;
					path.style.strokeDashoffset = `${length}`;
					path.style.strokeLinecap = "round";
					path.style.strokeLinejoin = "round";
					path.classList.add("is-spaceAnimation");
				});
			});
		}

		/*======================================
	Inside the Villaで追従に合わせて画像アニメーション
	======================================*/
		const section = document.querySelector(".secInside");
		if (!section) return;

		const cards = Array.from(
			section.querySelectorAll(".js-inside-card[data-room]"),
		);
		if (cards.length === 0) return;

		section.classList.add("is-scroll-switch");

		const insideMq = window.matchMedia("(max-width: 768px)");
		const IMAGE_FADE_MS = 650;
		const EPS = 1;

		// card と対応する .secInsideCard__img をセットで保持
		const items = cards
			.map((card) => {
				const room = card.dataset.room;
				const secInsideCard__img = card.querySelector(
					".secInsideCard__img",
				);

				return room && secInsideCard__img
					? { room: String(room), secInsideCard__img }
					: null;
			})
			.filter(Boolean);

		if (items.length === 0) return;

		const roomNumbers = items
			.map((item) => Number(item.room))
			.filter((n) => Number.isFinite(n))
			.sort((a, b) => a - b);

		const minRoom = roomNumbers[0] ?? 1;

		let currentRoom = String(minRoom);
		let currentImage = null;
		let switchToken = 0;
		const fullState = new Map();

		const isFullyVisible = (el) => {
			const rect = el.getBoundingClientRect();
			return rect.top >= -EPS && rect.bottom <= window.innerHeight + EPS;
		};

		const getActiveFixed = () => {
			return insideMq.matches
				? section.querySelector(".secInside__fixed.is-pc-hidden")
				: section.querySelector(".secInside__fixed.is-sp-hidden");
		};

		const getActiveImages = () => {
			const activeFixed = getActiveFixed();
			return activeFixed
				? Array.from(
						activeFixed.querySelectorAll(
							".secInside__animationImg",
						),
					)
				: [];
		};

		const getImageByRoomNumber = (roomNumber) => {
			const activeFixed = getActiveFixed();
			if (!activeFixed) return null;

			return (
				activeFixed.querySelector(
					`.secInside__animationImg.room${roomNumber}`,
				) ?? null
			);
		};

		const clearImageState = () => {
			getActiveImages().forEach((img) => {
				img.classList.remove("is-active");
				img.classList.remove("is-next");
			});
		};

		const setInitialActiveByRoomNumber = (roomNumber) => {
			currentRoom = String(roomNumber);
			currentImage = getImageByRoomNumber(currentRoom);

			clearImageState();

			if (currentImage) {
				currentImage.classList.add("is-active");
			}
		};

		const setActiveByRoomNumber = (roomNumber) => {
			const nextRoom = String(roomNumber);
			const nextImage = getImageByRoomNumber(nextRoom);
			const activeImages = getActiveImages();

			if (!nextImage || activeImages.length === 0) return;
			if (nextRoom === currentRoom && nextImage === currentImage) return;

			switchToken += 1;
			const token = switchToken;
			const prevImage = currentImage;

			if (!prevImage) {
				clearImageState();
				nextImage.classList.add("is-active");
				currentRoom = nextRoom;
				currentImage = nextImage;
				return;
			}

			nextImage.classList.add("is-next");

			window.requestAnimationFrame(() => {
				if (token !== switchToken) return;
				nextImage.classList.add("is-active");
			});

			const finalize = () => {
				if (token !== switchToken) return;

				activeImages.forEach((img) => {
					if (img === nextImage) {
						img.classList.add("is-active");
						img.classList.remove("is-next");
					} else {
						img.classList.remove("is-active");
						img.classList.remove("is-next");
					}
				});

				currentRoom = nextRoom;
				currentImage = nextImage;
			};

			const onTransitionEnd = (event) => {
				if (event.target !== nextImage) return;
				if (event.propertyName !== "opacity") return;
				finalize();
			};

			nextImage.addEventListener("transitionend", onTransitionEnd, {
				once: true,
			});

			window.setTimeout(() => {
				finalize();
			}, IMAGE_FADE_MS);
		};

		const pickInitial = () => {
			const fullNow = items
				.map(({ room, secInsideCard__img }) => ({
					room,
					rect: secInsideCard__img.getBoundingClientRect(),
					secInsideCard__img,
				}))
				.filter(({ secInsideCard__img }) =>
					isFullyVisible(secInsideCard__img),
				);

			if (fullNow.length > 0) {
				fullNow.sort((a, b) => a.rect.top - b.rect.top);
				currentRoom = String(fullNow[0].room);
			} else {
				currentRoom = String(minRoom);
			}

			setInitialActiveByRoomNumber(currentRoom);

			items.forEach(({ secInsideCard__img }) => {
				fullState.set(
					secInsideCard__img,
					isFullyVisible(secInsideCard__img),
				);
			});
		};

		pickInitial();

		let lastScrollY = window.scrollY;
		let scrollDir = "down";
		let rafId = null;

		const update = () => {
			rafId = null;

			const y = window.scrollY;
			if (y !== lastScrollY) {
				scrollDir = y > lastScrollY ? "down" : "up";
			}
			lastScrollY = y;

			const becameFull = [];
			let leftFullCurrent = false;

			for (const { room, secInsideCard__img } of items) {
				const prevFull = fullState.get(secInsideCard__img) ?? false;
				const nowFull = isFullyVisible(secInsideCard__img);
				const rect = secInsideCard__img.getBoundingClientRect();

				fullState.set(secInsideCard__img, nowFull);

				if (scrollDir === "down" && !prevFull && nowFull) {
					becameFull.push({ room, rect });
				}

				if (
					scrollDir === "up" &&
					prevFull &&
					!nowFull &&
					room === currentRoom
				) {
					leftFullCurrent = true;
				}
			}

			if (scrollDir === "up" && leftFullCurrent) {
				const next = Math.max(minRoom, Number(currentRoom) - 1);
				const nextRoom = String(next);

				if (nextRoom !== currentRoom) {
					setActiveByRoomNumber(nextRoom);
				}
				return;
			}

			if (scrollDir === "down" && becameFull.length > 0) {
				becameFull.sort((a, b) => b.rect.top - a.rect.top);
				const nextRoom = String(becameFull[0].room);

				if (nextRoom !== currentRoom) {
					setActiveByRoomNumber(nextRoom);
				}
			}
		};

		const requestUpdate = () => {
			if (rafId !== null) return;
			rafId = window.requestAnimationFrame(update);
		};

		window.addEventListener("scroll", requestUpdate, { passive: true });
		window.addEventListener(
			"resize",
			() => {
				pickInitial();
				requestUpdate();
			},
			{ passive: true },
		);

		insideMq.addEventListener("change", () => {
			pickInitial();
			requestUpdate();
		});

		requestUpdate();
	});
})();
